import React, {useContext, useEffect, useState} from "react";
import SwitchItem from "../../form/input/generated/SwitchItem";
import DateSelector from "../../form/input/generated/DateSelector";
import Download2Icon from "../../icons/Download2Icon";
import FiltersIcon from "../../icons/FiltersIcon";
import CancelIcon from "../../icons/CancelIcon";
import StatisticContext from "../../../context/StatisticContext";
import ListingContext from "../../../context/ListingContext";
import "../../../css/toolsBar/analyze/ToolsBar.css";
import LoaderCircle from "../../loader/LoaderCircle";

const ToolsBar = props => {
    const { classname, launchStats, launchExport, dateTypesAvailable } = props;
    const { dateType, setDateType, dates, setDates, loading } = useContext(StatisticContext);
    const { filters, filterValues, validFilters } = useContext(ListingContext);
    const { openFilters } = useContext(ListingContext);
    const [ listDateType, setListDateType ] = useState([]);
    const [ values, setValues ] = useState([]);
    const idRandom = Math.floor(Math.random() * 999999);

    const initListDateType = types => {
        let typesTmp = [];

        if (types === undefined || types === null || types.length === 0)
            types = ['D', 'M'];

        for (let i in types) {
            switch (types[i]) {
                case 'D':
                    typesTmp.push({
                        "value": "day",
                        "label": window.matchMedia('(max-width: 640px)').matches ? "J" : "Jour"
                    });
                    break;
                case 'M':
                    typesTmp.push({
                        "value": "month",
                        "label": window.matchMedia('(max-width: 640px)').matches ? "M" : "Mois"
                    });
                    break;
                case 'Q':
                    typesTmp.push({
                        "value": "quarter",
                        "label": window.matchMedia('(max-width: 640px)').matches ? "Q" : "Trimestre"
                    });
                    break;
                case 'Y':
                    typesTmp.push({
                        "value": "year",
                        "label": window.matchMedia('(max-width: 640px)').matches ? "A" : "Année"
                    });
                    break;
                default: break;
            }
        }

        setListDateType(typesTmp);
    }
    const clickAction = code => {
        switch (code) {
            case 100:
                if (loading.global) return;
                openFilters();
                break;
            case 101:
                launchExport();
                break;
            default:
                break;
        }
    }
    const changeDateType = type => {
        if (type === "day") {
            if (window.matchMedia('(max-width: 640px)').matches)
                type = "day";
            else
                type = "dual_day";
        }

        setDateType(type);
    }
    const changeDateSelected = (dates, refresh = false) => {
        setDates({
            begin: dates.begin,
            end: dates.end
        });
    }
    const displayFilterByAttribute = (attribute, index) => {
        switch (attribute) {
            case "license_id":
                if (filterValues.license_id !== undefined && filterValues.license_id !== null && filters.licenses.length > 1) {
                    const license = filters.licenses.find(_ => _.id === filterValues.license_id);

                    if (license !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Caisse</p>
                            </div>
                            <p className={"value"}>{license.name}</p>
                        </div>;
                    }
                }

                break
            case "seller_id":
                if (filterValues.seller_id !== undefined && filterValues.seller_id !== null && filters.sellers.length > 1) {
                    const seller = filters.sellers.find(_ => _.id === filterValues.seller_id);

                    if (seller !== undefined) {
                        return <div key={index} className={"filter"}>
                            <div className={"struct"}>
                                <div className={"close"} onClick={() => { removeFilter(attribute); }}><CancelIcon /></div>
                                <p className={"attribute"}>Vendeur</p>
                            </div>
                            <p className={"value"}>{seller.name}</p>
                        </div>;
                    }
                }

                break;
            default: break;
        }
    }
    const removeFilter = (attribute, target) => {
        let newValues = Object.assign({}, values);

        switch (attribute) {
            case "license_id":
                newValues.license_id = null;
                break;
            case "seller_id":
                newValues.seller_id = null;
                break;
            default: break;
        }

        validFilters(newValues);
    }

    useEffect(() => {
        initListDateType(dateTypesAvailable);
    }, [dateTypesAvailable]);
    useEffect(() => {
        setValues(filterValues);
    }, [filterValues]);

    return(
        <div className={ "toolsBarStatistics form" + (classname !== undefined ? " " + classname : "") }>
            <div className={"left"}>
                {
                    dateTypesAvailable.length > 1
                    && <SwitchItem attribute={"dateType"} returnType={"string"} classname={"marginBottom10"} list={listDateType} value={dateType} change={changeDateType} loadingDependant={true} />
                }
                <DateSelector random={idRandom} attribute={"dateSelected"} returnType={"string"} classname={"marginBottom10" + (dateTypesAvailable.length < 2 ? " noMarginLeft" : "")} type={dateType} value={dates} change={changeDateSelected} validCalendar={launchStats} noCompare={true} />
                <button className={"action marginLeft marginRight" + (loading.global ? " loadingLocked" : "")} onClick={() => { clickAction(100) }}>
                    <FiltersIcon classname={"icon"} />
                </button>
                <div className={"filtersList"}>
                    {
                        (filterValues !== null && filterValues !== undefined) &&
                        Object.keys(filterValues).map((attribute, index) => displayFilterByAttribute(attribute, index))
                    }
                </div>
            </div>
            <div className={"right"}>
                <LoaderCircle display="loader inToolsbar" hide={(!loading.global ? "hide" : "")} strokeWidth="8" stroke="#FFFFFF" />
                <button className={"action"} onClick={() => { clickAction(101) }}>
                    <Download2Icon classname={"icon download"} />
                </button>
            </div>
        </div>
    );
}

export default ToolsBar;
